import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect,
} from 'react';

const HeadlineContext = createContext([false, () => {}]);

const HeadlineProvider = ({ children }) => {
  const state = useRef(false);
  const setState = (value) => (state.current = value);

  return (
    <HeadlineContext.Provider value={[state, setState]}>
      {children}
    </HeadlineContext.Provider>
  );
};

const useHeadlineContext = (isReadOnly, isHeading) => {
  const [state, setState] = useContext(HeadlineContext);
  const [isHeadline, setHeadline] = useState(false);

  useEffect(() => {
    if (isReadOnly) {
      return;
    }
    if (isHeading && !state.current) {
      setHeadline(true);
      setState(true);
    }
  }, []);

  return [isHeadline, state.current];
};

export { HeadlineContext, HeadlineProvider, useHeadlineContext };
